module.exports = __webpack_public_path__ + "static/media/image29.f9db9492.png";